import React, { useState } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import { API_URL } from './config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TableInventoryFBA from './components/TableInventoryFBA';

function InventoryFBA() {
  return (
    <>
      <Container>
        <HeaderLogged />
        
      </Container>
      <TableInventoryFBA />
    </>
  );
}

export default InventoryFBA;